const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "FISHING_VESSEL_PREFIX_RETRIEVED":
            return action.fishingVesselPrefixes;

        default:
            return state;
    }
}
